import { useTranslations } from 'next-intl'

import Switch from '../../../../../Switch'

import { TrackingType } from './CookieBanner.types'
import { TRACKING_TEXT_TRANSLATION_KEYS } from './CookieBanner.constants'

interface Props {
  isChecked?: boolean
}

interface DisabledProps extends Props {
  type: 'ESSENTIAL'
}

interface InteractiveProps extends Props {
  type: TrackingType
  toggleOption: (type: TrackingType) => (event: React.ChangeEvent<HTMLInputElement>) => void
}

const TrackingOptionToggle = (props: DisabledProps | InteractiveProps) => {
  const { type, isChecked } = props
  const { title, description } = TRACKING_TEXT_TRANSLATION_KEYS[type]

  const t = useTranslations('cookies')

  switch (type) {
    case 'ESSENTIAL':
      return (
        <div className="flex flex-col gap-1">
          <Switch labelText={<p className="font-bold">{t(title)}</p>} disabled checked={isChecked} />
          <p className="text-center text-base">{t(description)}</p>
        </div>
      )
    default:
      return (
        <div className="flex flex-col gap-1">
          <Switch
            checked={props.isChecked}
            handleChange={props.toggleOption(type)}
            labelText={<p className="font-bold">{t(title)}</p>}
          />
          <p className="text-center text-base">{t(description)}</p>
        </div>
      )
  }
}

export default TrackingOptionToggle
